import React from 'react';
import { sessionsApi } from '../api/sessionsApi';
import { mapApiSessionsToGrid } from '../utils/mapSessions';

export function useWeeklySessions(weekStartISO) {
  const [sessions, setSessions] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const fetchWeekly = React.useCallback(async () => {
    setLoading(true);
    try {
      const res = await sessionsApi.listWeekly({ day: weekStartISO });
      const data = res?.data ?? res;

      setSessions(mapApiSessionsToGrid(data));
    } catch (e) {
      console.error('[sessions] weekly load failed', e);
      setSessions([]);
    } finally {
      setLoading(false);
    }
  }, [weekStartISO]);

  React.useEffect(() => {
    fetchWeekly();
  }, [fetchWeekly]);

  return { sessions, loading, fetchWeekly, setSessions };
}
